module.exports = __webpack_public_path__ + "img/design-banner.c306083f.jpg";